export default function createServiceTranslations(translations) {
  if (!translations) {
    return {};
  }

  return Object.entries(translations)
    .reduce((acc, [key, localeTranslation]) => {
      acc[key] = {
        metaDescription: localeTranslation?.meta_description ?? '',
        metaTitle: localeTranslation?.meta_title ?? '',
      };

      return acc;
    }, {});
}
